module.exports = __webpack_public_path__ + "static/media/nft-DomeOnGradientBackground.bd645e9a.png";